import {Component} from '@angular/core';
/**
 * \@title Basic cards
 */
export class CardOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'card-overview-example',
  templateUrl: 'card-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CardOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
CardOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CardOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
